import React from 'react';
import PropTypes from 'prop-types';
import {GroupedSelectBox} from '@adsk/bim360-matrix-react-select-box';
import {
  TEMPLATE_CATEGORY_FIELD_NAMES,
  TEMPLATE_FIELD_NAMES,
  TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES
} from '../../constants/issue-templates';
import {templateCategoryType, templatesCollectionType} from '../../constants/proptype-validation';
import lodashGet from 'lodash/get';
import lodashGroupBy from 'lodash/groupBy';
import i18n from '../../utils/i18n';

const labelGetter = template =>
  lodashGet(template, [TEMPLATE_FIELD_NAMES.ISSUE_ATTRIBUTES, TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.TITLE]);

const getGroupedTemplatesAndSelectedTemplate = (
  templateCategories,
  activeTemplates,
  recentlyUsedTemplates,
  uncategorizedCategoryId,
  selectedTemplateId
) => {
  const activeTemplatesWithValue = activeTemplates.map(template => ({...template, value: template.id}));
  const selectedTemplate = activeTemplatesWithValue.find(({value}) => value === selectedTemplateId) || null;
  const groups = lodashGroupBy(activeTemplatesWithValue, TEMPLATE_FIELD_NAMES.CATEGORY_ID);
  const templatesGroups = templateCategories
    .filter(({[TEMPLATE_CATEGORY_FIELD_NAMES.ID]: groupId}) => groups[groupId])
    .map(({[TEMPLATE_CATEGORY_FIELD_NAMES.ID]: id, [TEMPLATE_CATEGORY_FIELD_NAMES.TITLE]: title}) => ({
      id,
      title,
      templates: groups[id]
    }));

  return {
    groupedTemplates: [
      {
        id: 'recently-used',
        title: i18n.t('createFromTemplate.recentlyUsed'),
        templates: recentlyUsedTemplates.map(template => ({...template, value: `recent-${template.id}`}))
      },
      ...templatesGroups,
      {
        id: uncategorizedCategoryId,
        title: i18n.t('templateAttributes.category.uncategorized'),
        templates: groups[uncategorizedCategoryId]
      }
    ],
    selectedTemplate
  };
};

const TemplateSelector = ({
  templateCategories,
  activeTemplates,
  recentlyUsedTemplates,
  uncategorizedCategoryId,
  onSelect,
  selectedTemplateId,
  disabled
}) => {
  const {groupedTemplates, selectedTemplate} = getGroupedTemplatesAndSelectedTemplate(
    templateCategories,
    activeTemplates,
    recentlyUsedTemplates,
    uncategorizedCategoryId,
    selectedTemplateId
  );

  return (
    <GroupedSelectBox
      disabled={disabled}
      clearable
      searchable
      options={groupedTemplates}
      groupLabelKey={TEMPLATE_CATEGORY_FIELD_NAMES.TITLE}
      groupOptionsKey="templates"
      labelGetter={labelGetter}
      value={selectedTemplate}
      onChange={onSelect}
    />
  );
};

TemplateSelector.displayName = 'TemplateSelector';

TemplateSelector.propTypes = {
  templateCategories: PropTypes.arrayOf(templateCategoryType),
  activeTemplates: templatesCollectionType,
  recentlyUsedTemplates: templatesCollectionType,
  uncategorizedCategoryId: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedTemplateId: PropTypes.string,
  disabled: PropTypes.bool
};

export default TemplateSelector;
